var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    _vm._g(
      _vm._b(
        {
          ref: "virtualSelect",
          staticClass: "virtual-select",
          on: { clear: _vm.resetChecked, focus: _vm.selectFocus },
          model: {
            value: _vm.selected,
            callback: function($$v) {
              _vm.selected = $$v
            },
            expression: "selected"
          }
        },
        "el-select",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _vm._l([], function(item) {
        return _c("el-option", {
          key: item.value,
          attrs: { label: item.label, value: item.value }
        })
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "virtual-select__box",
          attrs: { slot: "empty" },
          slot: "empty"
        },
        [
          _c("diyInput", {
            attrs: { clearable: "", placeholder: "输入关键字进行过滤" },
            on: { input: _vm.inputChange },
            model: {
              value: _vm.filterText,
              callback: function($$v) {
                _vm.filterText = $$v
              },
              expression: "filterText"
            }
          }),
          _vm._v(" "),
          _c(
            "virtual-tree",
            _vm._b(
              {
                ref: "virtualTree",
                attrs: {
                  data: _vm.originData,
                  props: _vm.props,
                  multiple: _vm.isMultiple,
                  expandLevel: _vm.expandLevel,
                  checked: _vm.checkedValues,
                  showDelete: _vm.isShowDelete
                },
                on: { change: _vm.checkedChange }
              },
              "virtual-tree",
              _vm.$attrs,
              false
            )
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f99f92a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f99f92a8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/virtualTree/index.vue
// module id = null
// module chunks = 